module.exports = __webpack_public_path__ + "img/banner-1.6ae993dc.jpg";